/**
 * The address one sub-product's line item is filed under: `productSlug|fieldKey|optionKey`.
 *
 * The backend keys every Sales Price by this catalog triple (`audience_request_product_lines`).
 * The push modal and the Overview Products card both build it, so one helper keeps the two from
 * drifting into different spellings of the same key (NPJB-768).
 */
export const lineKey = (productSlug: string, fieldKey: string, optionKey: string): string =>
  `${productSlug}|${fieldKey}|${optionKey}`;
